module.exports = "/_next/static/images/menu-23b32c26a0e4d3f871a53a249cd00d1e.svg";